import React from 'react'

function EmployeePayslipLoading() {
  return (
    <>
     {Array.from({length:8}).map((_,index)=>(
     <div className='flex flex-col gap-2 p-4 bg-slate-300 rounded-lg shadow-md animate-pulse w-full h-24' key={index}>

     </div>
    ))}
    </>
  )
}

export default EmployeePayslipLoading
